import { StyleSheet } from 'aphrodite';
import { header } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	container: {},
	header: {
		fontSize: 18,
	},
	text: {
		color: header,
		fontSize: 14,
		padding: '20px 0',
	},
});
